module.exports = __webpack_public_path__ + "img/40_69_002_420.49dcec88.jpg";